export enum WorkItemStatus {
  DRAFT = 0,
  PAYMENT_REQUESTED = 1,
  PAYMENT_APPROVED = 2,
  PAYMENT_SIGNED = 3,
  PAID = 4,
  REFUNDED = 5,
  WORK_APPROVAL = 6,
}

export enum WorkItemEntityType {
  CUSTOM_WORK = "custom_work",
  CUSTOM_PAYMENT = "custom_payment",
  CUSTOM_TASK = "custom_task",
  WORKFLOW_TASK = "workflow_task",
  SMM_BONUS = "smm_bonus",
  FINDER_BONUS = "finder_bonus",
}
